import React, { useState, useEffect, useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { login, logoff,loadUserFromStorage } from "_services/oauth";
import axios from "utils/httpClient";
import { authHeader } from "_helpers";
import store from "store";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import Datetime from 'react-datetime';
import Select from 'react-select';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSUser from "components/Forms/TSUser"; 
import TSSelect2 from "components/Forms/TSSelect2";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import { Collapse, Modal, ModalBody } from "reactstrap";
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";
import Meeting from "layouts/HR";
import { Phone } from "@material-ui/icons";


const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  },
  cardTitleCustom: {
      background: "linear-gradient(to right, #ff7e5f, #feb47b)",
      margin: "-20px 15px 15px 15px"
  }
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);

const Request = (props) => {

  const _vbID = (props.match.params.VBID !== undefined) ? props.match.params.VBID : null;

  const { location, ...other } = props;
  const user = useSelector((state) => state.auth.user);
  const history = useHistory();

  var moment = require('moment');
  require('moment/locale/th');

  const [currentDate, setcurrentDate] = useState(moment());
  const [holidayText, setHolidayText] = useState('');
  const [holidays, setHolidays] = useState([]);



    const [StartPlace, setStartPlace] = useState("โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จังหวัดตรัง"); 
    const [EndPlace, setEndPlace] = useState(""); 
    const [VBDescription, setVBDescription] = useState("");
    const [VBObjective, setVBObjective] = useState(""); 
    const [StartDatetime, setStartDatetime] = useState("");
    const [StartTime, setStartTime] = useState("");
    const [EndDatetime, setEndDatetime] = useState("");
    const [EndTime, setEndTime] = useState(""); 
    const [IsOneWay, setIsOneWay] = useState(false);
    const [TotalPassenger, setTotalPassenger] = useState(0);
    const [ContactPhone, setContactPhone] = useState(""); 



  const [VBKey, setVBKey] = useState(null); 
  const [VBID, setVBID] = useState(null); 
  const [VBTypeKey, setVBTypeKey] = useState(null); 
  const [TeamGroupTypeKey, setTeamGroupTypeKey] = useState(null); 
  const [TeamGroupKey, setTeamGroupKey] = useState(null); 
  const [DepartmentKey, setDepartmentKey] = useState(null); 
  const [TeamName, setTeamName] = useState(null); 
  const [VBName, setVBName] = useState(null); 

  const [VBStatusKey, setVBStatusKey] = useState(null); 
  const [VehicleKey, setVehicleKey] = useState(null); 
  const [VehicleOther, setVehicleOther] = useState(null); 
  const [VBStyleKey, setVBStyleKey] = useState(null); 

  const [StartLatLong, setStartLatLong] = useState(null); 
  const [EndLatLong, setEndLatLong] = useState(null); 

  const [StartGauge, setStartGauge] = useState(null); 
  const [EndGauge, setEndGauge] = useState(null); 
  const [DriverUserName, setDriverUserName] = useState(null); 
  const [ApproveCode, setApproveCode] = useState(null); 
  const [ApproveDatetime, setApproveDatetime] = useState(null);
  //const [ApproveDatetime_Time, setApproveDatetime_Time] = useState(null); 
  const [CreatorCode, setCreatorCode] = useState(null); 
  const [CreateDatetime, setCreateDatetime] = useState(null);
  //const [CreateDatetime_Time, setCreateDatetime_Time] = useState(null); 
  const [LastEditerCode, setLastEditerCode] = useState(null); 
  const [LastEditDatetime, setLastEditDatetime] = useState(null);
  //const [LastEditDatetime_Time, setLastEditDatetime_Time] = useState(null); 
  const [IsCancel, setIsCancel] = useState(null); 
  const [CancelCode, setCancelCode] = useState(null); 
  const [CancelDatetime, setCancelDatetime] = useState(null);
  //const [CancelDatetime_Time, setCancelDatetime_Time] = useState(null);
  
  const [CreatorName, setCreatorName] = useState("");
  const [EditerName, setEditerName] = useState("");
  const [CancelerName, setCancelerName] = useState("");


  const [ArrVB, setVB] = useState([]); 
  const [ArrVBType, setVBType] = useState([]); 
  const [ArrTeamGroupType, setTeamGroupType] = useState([]); 
  const [ArrTeamGroup, setTeamGroup] = useState([]); 
  const [ArrDepartment, setDepartment] = useState([]); 
  const [ArrVBStatus, setVBStatus] = useState([]); 
  const [ArrVehicle, setVehicle] = useState([]); 
  const [ArrVBStyle, setVBStyle] = useState([]); 

  const [Attendee, setAttendee] = useState([]);

  const [modalHoliday, setModalHoliday] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");


  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [dateFocus, setDateFocus] = useState(false);

  const arrTime = [
    { label:"7:00 น.", value:'07:00', isDisabled: false},
    { label:"7:30 น.", value:'07:30', isDisabled: false},
    { label:"8:00 น.", value:'08:00', isDisabled: false},
    { label:"8:30 น.", value:'08:30', isDisabled: false},
    { label:"9:00 น.", value:'09:00', isDisabled: false},
    { label:"9:30 น.", value:'09:30', isDisabled: false},
    { label:"10:00 น.", value:'10:00', isDisabled: false},
    { label:"10:30 น.", value:'10:30', isDisabled: false},
    { label:"11:00 น.", value:'11:00', isDisabled: false},
    { label:"11:30 น.", value:'11:30', isDisabled: false},
    { label:"12:00 น.", value:'12:00', isDisabled: false},
    { label:"12:30 น.", value:'12:30', isDisabled: false},
    { label:"13:00 น.", value:'13:00', isDisabled: false},
    { label:"13:30 น.", value:'13:30', isDisabled: false},
    { label:"14:00 น.", value:'14:00', isDisabled: false},
    { label:"14:30 น.", value:'14:30', isDisabled: false},
    { label:"15:00 น.", value:'15:00', isDisabled: false},
    { label:"15:30 น.", value:'15:30', isDisabled: false},
    { label:"16:00 น.", value:'16:00', isDisabled: false},
    { label:"16:30 น.", value:'16:30', isDisabled: false},
    { label:"17:00 น.", value:'17:00', isDisabled: false},
    { label:"17:30 น.", value:'17:30', isDisabled: false},
    { label:"18:00 น.", value:'18:00', isDisabled: false},
    { label:"18:30 น.", value:'18:30', isDisabled: false},
    { label:"19:00 น.", value:'19:00', isDisabled: false},
    { label:"19:30 น.", value:'19:30', isDisabled: false},
    { label:"20:00 น.", value:'20:00', isDisabled: false},
    { label:"20:30 น.", value:'20:30', isDisabled: false}
];

const arrTime2 = [
  { label:"07:30 น.", value:'07:30', isDisabled: false},
  { label:"8:00 น.", value:'08:00', isDisabled: false},
  { label:"8:30 น.", value:'08:30', isDisabled: false},
  { label:"9:00 น.", value:'09:00', isDisabled: false},
  { label:"9:30 น.", value:'09:30', isDisabled: false},
  { label:"10:00 น.", value:'10:00', isDisabled: false},
  { label:"10:30 น.", value:'10:30', isDisabled: false},
  { label:"11:00 น.", value:'11:00', isDisabled: false},
  { label:"11:30 น.", value:'11:30', isDisabled: false},
  { label:"12:00 น.", value:'12:00', isDisabled: false},
  { label:"12:30 น.", value:'12:30', isDisabled: false},
  { label:"13:00 น.", value:'13:00', isDisabled: false},
  { label:"13:30 น.", value:'13:30', isDisabled: false},
  { label:"14:00 น.", value:'14:00', isDisabled: false},
  { label:"14:30 น.", value:'14:30', isDisabled: false},
  { label:"15:00 น.", value:'15:00', isDisabled: false},
  { label:"15:30 น.", value:'15:30', isDisabled: false},
  { label:"16:00 น.", value:'16:00', isDisabled: false},
  { label:"16:30 น.", value:'16:30', isDisabled: false},
  { label:"17:00 น.", value:'17:00', isDisabled: false},
  { label:"17:30 น.", value:'17:30', isDisabled: false},
  { label:"18:00 น.", value:'18:00', isDisabled: false},
  { label:"18:30 น.", value:'18:30', isDisabled: false},
  { label:"19:00 น.", value:'19:00', isDisabled: false},
  { label:"19:30 น.", value:'19:30', isDisabled: false},
  { label:"20:00 น.", value:'20:00', isDisabled: false},
  { label:"20:30 น.", value:'20:30', isDisabled: false},
  { label:"21:00 น.", value:'21:00', isDisabled: false}
];

const [ArrStartTime, setArrStartTime] = useState(arrTime);
const [ArrStopTime, setArrStopTime] = useState(arrTime2);

const myRef = useRef(null);


var token = localStorage.getItem("token");


  useEffect(() => {


      if (_vbID != null && _vbID != '') {
          props.history.push({
              pathname: '/vehicle/request',
              state: {
                  VBID: _vbID
              }
          })
      }

    axios("/api/v1/vehicle/vb")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"vbKey":').join('"value":'));
            setVB(json)
        }, error => { console.log(error); }
    );  

    axios("/api/v1/vehicle/vbtype")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"vbTypeKey":').join('"value":'));
            setVBType(json)
        }, error => { console.log(error); }
    );  

    axios("/api/v1/vehicle/teamgrouptype")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"teamGroupTypeKey":').join('"value":'));
            setTeamGroupType(json)
        }, error => { console.log(error); }
    );  

    axios("/api/v1/vehicle/teamgroup")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"teamGroupKey":').join('"value":'));
            setTeamGroup(json)
        }, error => { console.log(error); }
    );  

    axios("/api/v1/vehicle/department")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"departmentKey":').join('"value":'));
            setDepartment(json)
        }, error => { console.log(error); }
    );  

    axios("/api/v1/vehicle/vbstatus")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"vbStatusKey":').join('"value":'));
            setVBStatus(json)
        }, error => { console.log(error); }
    );  

    axios("/api/v1/vehicle/vehicle")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"vehicleKey":').join('"value":'));
            setVehicle(json)
        }, error => { console.log(error); }
    );

    axios("/api/v1/vehicle/vbstyle")
    .then(
      result => {
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"vbStyleKey":').join('"value":'));
            setVBStyle(json)
        }, error => { console.log(error); }
    );  


    if(location.state != null)
    {
      if (location.state.VBID != null && location.state.VBID != '')
      {
        setIsEdit(true)

        axios({
          method: 'get',
            url: "/api/v1/vehiclebooking/" + location.state.VBID,
            headers: { 'referpage': '/vehicle/request/'+ location.state.VBID }
        })
        .then(
            resEdit => {
              var res=resEdit.data.data;
              //console.log(resEdit)

              setVBKey(res.vbKey) 
              setVBID(res.vbID) 
              setVBTypeKey(res.vbTypeKey) 
              setTeamGroupTypeKey(res.teamGroupTypeKey) 
              setTeamGroupKey(res.teamGroupKey) 
              setDepartmentKey(res.departmentKey) 
              setTeamName(res.teamName) 
              setVBName(res.vbName) 
              setVBDescription(res.vbDescription)   
              setVBObjective(res.vbObjective) 
              setVBStatusKey(res.vbStatusKey) 
              setVehicleKey(res.vehicleKey) 
              setVehicleOther(res.vehicleOther) 
              setVBStyleKey(res.vbStyleKey) 
              setStartPlace(res.startPlace) 
              setEndPlace(res.endPlace) 
              setStartLatLong(res.startLatLong) 
              setEndLatLong(res.endLatLong) 
              setTotalPassenger(res.totalPassenger) 
              setStartDatetime(moment(res.startDatetime).format('YYYY-MM-DD').toString())
              setStartTime(moment(res.startDatetime).format('HH:mm'))

              setIsOneWay(Number(res.isOneWay) === 1);
              setEndDatetime(Number(res.isOneWay) === 1 || !res.endDatetime ? "" : moment(res.endDatetime).format('YYYY-MM-DD'));
              setEndTime(Number(res.isOneWay) === 1 || !res.endDatetime ? "" : moment(res.endDatetime).format('HH:mm'));

              setStartGauge(res.startGauge) 
              setEndGauge(res.endGauge) 
              setContactPhone(res.contactPhone) 
              setDriverUserName(res.driverUserName) 
              setApproveCode(res.approveCode) 
              setApproveDatetime(moment(res.approveDatetime).format('YYYY-MM-DD').toString())


              setCreatorCode(res.creatorCode) 
              setCreateDatetime(moment(res.createDatetime).format('YYYY-MM-DD').toString())

              setLastEditerCode(res.lastEditerCode) 
              setLastEditDatetime(moment(res.lastEditDatetime).format('YYYY-MM-DD').toString())


              setIsCancel(res.isCancel) 
              setCancelCode(res.cancelCode) 
              setCancelDatetime(moment(res.cancelDatetime).format('YYYY-MM-DD').toString())


              setCreatorName(resEdit.data.creatorName);
              setEditerName(resEdit.data.editerName);
              setCancelerName(resEdit.data.cancelerName);

                
              const _rAttendee = res.vbPassenger.map(row => {
                    row.userView['attendStatusKey'] = (row.attendStatusKey != null) ? row.attendStatusKey : 0;
                    return row.userView;
              });
              setAttendee(_rAttendee)
                
              
            },
            error => {

            }
        );  

      }
      else{
        //auto assign จาก parameter จากหน้า list
        //setRoomKey(location.state.roomKey)
        //setMeetingName(location.state.meetingName)
        //setStartDatetime(moment(location.state.startDatetime).format('YYYY-MM-DD').toString())
        //setEndDatetime(moment(location.state.stopDatetime).format('YYYY-MM-DD').toString())
        //setStartTime(moment(location.state.startDatetime).format('HH:mm'))
        //setEndTime(moment(location.state.stopDatetime).format('HH:mm'))  
      }
    }
    else{
      
    }

  
  }, [/*token*/]);

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

     
    if(StartPlace == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ สถานที่ต้นทาง"}</li>);
    }
    
    if(EndPlace == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ สถานที่ปลายทาง"}</li>);
    }
        
    if(VBObjective == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ วัตถุประสงค์ของการใช้รถ"}</li>);
    }

    if(StartDatetime == '' || StartTime == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ วันเวลาเริ่มต้น"}</li>);
    }
    
    if(!IsOneWay && (EndDatetime == '' || EndTime == ''))
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ วันเวลาสิ้นสุด"}</li>);
      }

    if(ContactPhone == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ หมายเลขโทรศัพท์ติดต่อผู้ขอใช้"}</li>);
    }

    if (!((Attendee != null && Attendee.length > 0) || (TotalPassenger != null && TotalPassenger > 0))) {
        cntErr += 1;
        errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ ผู้โดยสาร"}</li>);
    }



    /* 
    if(VBKey == null || VBKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VBKey"}</li>);
    }
    
    if(VBID == null || VBID =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VBID"}</li>);
    }
    
    if(VBTypeKey == null || VBTypeKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VBTypeKey"}</li>);
    }
    
    if(TeamGroupTypeKey == null || TeamGroupTypeKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ TeamGroupTypeKey"}</li>);
    }
    
    if(TeamGroupKey == null || TeamGroupKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ TeamGroupKey"}</li>);
    }
    
    if(DepartmentKey == null || DepartmentKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ DepartmentKey"}</li>);
    }
    
    if(TeamName == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ TeamName"}</li>);
    }
    
    if(VBName == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VBName"}</li>);
    }
  
    if(VBStatusKey == null || VBStatusKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VBStatusKey"}</li>);
    }
    
    if(VehicleKey == null || VehicleKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VehicleKey"}</li>);
    }
    
    if(VehicleOther == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VehicleOther"}</li>);
    }
    
    if(VBStyleKey == null || VBStyleKey =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ VBStyleKey"}</li>);
    }
    
    if(StartLatLong == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ StartLatLong"}</li>);
    }
    
    if(EndLatLong == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ EndLatLong"}</li>);
    }

    if(StartGauge == null || StartGauge =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ StartGauge"}</li>);
    }
    
    if(EndGauge == null || EndGauge =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ EndGauge"}</li>);
    }

    if(DriverUserName == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ DriverUserName"}</li>);
    }
    
    if(ApproveCode == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ ApproveCode"}</li>);
    }
    
    if(ApproveDatetime == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ ApproveDatetime"}</li>);
    }
    
    if(CreatorCode == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ CreatorCode"}</li>);
    }
    
    if(CreateDatetime == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ CreateDatetime"}</li>);
    }
    
    if(LastEditerCode == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ LastEditerCode"}</li>);
    }
    
    if(LastEditDatetime == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ LastEditDatetime"}</li>);
    }
    
    if(IsCancel == null || IsCancel =='')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ IsCancel"}</li>);
    }
    
    if(CancelCode == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ CancelCode"}</li>);
    }
    
    if(CancelDatetime == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุ CancelDatetime"}</li>);
    }
    */

    //if(Attendee == null || Attendee.length == 0)
    //{
    //  cntErr+=1;
    //  errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้เข้าร่วม"}</li>);
    //}

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }
  };

  const handleCancel = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");



    axios.put('/api/v1/vehicle/cancel/' + VBID, null)
          .then(
              result => {
 
                  if (result.data.result == 200) {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setModal2(true)
                  }
                  else {
                      setIcon("far fa-question-circle");
                      setModalCancel(false)
                      setErrMsg(result.data.msg)
                      setModalError(true)
                  }

              },
              error => { console.log(error); }
    );  

  };

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


    const _atd = [];
    Attendee.map((row) => (
      _atd.push({ userName : row.userName})
    ));


    var body = {

      startPlace: StartPlace,
      endPlace: EndPlace, 
      vbObjective: VBObjective, 
      startDatetime: StartDatetime + ' ' + StartTime,
      endDatetime: IsOneWay ? null : EndDatetime + ' ' + EndTime,
      isOneWay: IsOneWay,
      vbDescription: VBDescription, 
      contactPhone: ContactPhone, 
      totalPassenger: TotalPassenger, 
      vbPassenger: _atd
      /*

      vbKey: VBKey, 
      vbID: VBID, 
      vbTypeKey: VBTypeKey, 
      teamGroupTypeKey: TeamGroupTypeKey, 
      teamGroupKey: TeamGroupKey, 
      departmentKey: DepartmentKey, 
      teamName: TeamName, 
      vbName: VBName, 
      vbStatusKey: VBStatusKey, 
      vehicleKey: VehicleKey, 
      vehicleOther: VehicleOther, 
      vbStyleKey: VBStyleKey, 
      startLatLong: StartLatLong, 
      endLatLong: EndLatLong, 
      startGauge: StartGauge, 
      endGauge: EndGauge, 
      driverUserName: DriverUserName, 
      approveCode: ApproveCode, 
      approveDatetime: ApproveDatetime, 
      creatorCode: CreatorCode, 
      createDatetime: CreateDatetime, 
      lastEditerCode: LastEditerCode, 
      lastEditDatetime: LastEditDatetime, 
      isCancel: IsCancel, 
      cancelCode: CancelCode, 
      cancelDatetime: CancelDatetime, 
      */
      //meetingDataAttendee : _atd,
     }
     //console.log(body) 

      //แก้ไข
      if(location.state != null && location.state.VBID != null && location.state.VBID != '')
      {

        // (url,body)
        axios.put('/api/v1/vehiclebooking/'+location.state.VBID, body)
        .then(
          result => {
            
            //console.log(result)

            if(result.data.result == 200)
            {
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setModal2(true)
            }
            else
            {
              setIcon("far fa-question-circle"); 
              setModal(false) 
              setErrMsg(result.data.msg)
              setModalError(true) 
            }
  
          },
          error => { setIcon("far fa-question-circle"); setModal(false); setErrMsg(error.response?.data?.msg || "ไม่สามารถบันทึกคำขอใช้รถได้"); setModalError(true); }
        );  
      }
      else{
        //ลงทะเบียนใหม่
        axios("/api/v1/vehiclebooking", {
          method: 'POST',
          data: body,
          headers: authHeader()
        })
        .then(response => response.data)
        .then(
            result => {
              
              if(result.result == 200)
              {
                setVBID(result.data.vbID)
                setIcon("far fa-question-circle"); 
                setModal(false) 
                setModal2(true)
              }
              else
              {
                setIcon("far fa-question-circle"); 
                setModal(false) 
                setErrMsg(result.msg)
                setModalError(true)    
              }
    
            },
            error => { setIcon("far fa-question-circle"); setModal(false); setErrMsg(error.response?.data?.msg || "ไม่สามารถบันทึกคำขอใช้รถได้"); setModalError(true); }
          );  
      }

  };

  const GotoEdit = evt => {
      if (evt && typeof evt.preventDefault === 'function') {
          evt.preventDefault();
      }
      setModal2(false);
      const nav = props.history || history;
      if (nav && typeof nav.push === 'function') {
          nav.push({ pathname: '/vehicle/me' });
      }
  };

    
  const test = e => {
        myRef.current.scrollIntoView()
  };

  const handleAttendee = (_val) => {
    setAttendee(_val);

    //ตัวแปล จำนวนจาก array count
    setTotalPassenger(_val.length);
  };

  const handleStartTime = (_val) => {
      setStartTime(_val);

      if (arrTime != null) {
        const val = arrTime2.filter(e => moment('2023-01-01 ' + e.value) > moment('2023-01-01 ' +_val))
        setArrStopTime(val);
        //console.log(val)
      }
  };

  const handleStartDatetime = (date) => {
    setStartDatetime(date);
    if (!IsOneWay) setEndDatetime(date);
  }
  const handleEndDatetime = (date) => {
    setEndDatetime(date);
  }

  const fetchHoliday = (yearMonth) => {

  };

  const handleCurrentDate = (dayAmt, unit) => {
      var curr = moment(currentDate).add(dayAmt, unit)
      setcurrentDate(curr);
      fetchHoliday(curr.format('YYYY/M'));
      return false;
  }

  const handleNavigate = (nextView, currentView, currDate) => {
      if (nextView == 'days') {
          setcurrentDate(currDate);
          fetchHoliday(currDate.format('YYYY/M'));
      }
      return nextView;
  }

  const handleHoliday = (txt) => {
      setHolidayText(txt);
      setModalHoliday(true);
  }

  function isDateValid(e, selectedDate) {
      var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
      //return current.day() !== 0 && current.day() !== 6;
      if (holiday != null)
          return false
      else
          // แก้ให้จองวันเสาร์ return (e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate() - 1)))
          return (e.day() !== 0 && e > (new Date()).setDate((new Date().getDate() - 1)))
  }

  function renderDay(props, currentDate, selectedDate) {
      var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
      var hdt = (holiday != null) ? holiday.name : '';

      // Adds 0 to the days in the days view
      // แก้ให้จองวันเสาร์ได้ if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0 && currentDate.day() !== 6 && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {
      if ((props.className.indexOf('rdtDisabled') >= 0) && (currentDate.day() !== 0  && currentDate > (new Date()).setDate((new Date().getDate() - 1)))) {    
        props.className += ' text-danger';
          //return <td {...props} style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</td>;
          return <td >
              <button
                  onClick={e => handleHoliday(hdt)}
                  class="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
              >
                  <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
              </button>
          </td>; 
      }
      else {
          return <td {...props}>{currentDate.date()}</td>;
      }
  }

    const classes = useStyles();

    return (

        <div>

            <Grid>

                <Col xs={12} sm={12} md={12}>

                    <Card>
                        <CardHeader className={classes.cardTitleCustom}>

                            <h4 className={classes.cardTitleWhite}>แบบฟอร์มขออนุญาติใช้รถส่วนกลาง</h4>
                            <p className={classes.cardCategoryWhite}> กรุณาระบุรายละเอียด </p>

                        </CardHeader>

                        <CardBody>
                            
                            <Grid>

                            {/*
                            <Col xs={12} sm={12} md={12}>
                                  <div className="textarea-container" style={{ padding: 0 }}>
                                        <Label for="Address">รายละเอียด </Label>  
                                        <Input
                                            id="MeetingDescription"
                                            cols="80"
                                            name="MeetingDescription"
                                            placeholder="รายละเอียด"
                                            rows="4"
                                            type="textarea"
                                            className="custom"
                                            style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                            value={MeetingDescription}
                                            onChange={e => setMeetingDescription(e.target.value) }
                                            ></Input>
                                    </div>
                                </Col>
                            */}

                                <Col xs={12} sm={12} md={6}>
                                    <TSText icon="far fa-edit" label="จากสถานที่" value={StartPlace} onChange={e => setStartPlace(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                    <TSText icon="far fa-edit" label="ไปยังสถานที่" value={EndPlace} onChange={e => setEndPlace(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={12}>
                                    <div className="textarea-container" style={{ padding: 0 }}>
                                        <Label for="Address">วัตถุประสงค์ของการขอใช้รถ </Label>
                                        {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                        <Input
                                            id="VBObjective"
                                            cols="80"
                                            name="VBObjective"
                                            placeholder="วัตถุประสงค์ของการขอใช้รถ"
                                            rows="4"
                                            type="textarea"
                                            className="custom"
                                            style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                            value={VBObjective}
                                            onChange={e => setVBObjective(e.target.value)}
                                        ></Input>
                                    </div>
                                </Col>


                                <Col xs={12}>
                                    <FormControlLabel
                                        control={<Checkbox color="primary" checked={IsOneWay} onChange={event => {
                                            const checked = event.target.checked;
                                            setIsOneWay(checked);
                                            setEndDatetime(checked ? "" : StartDatetime);
                                            setEndTime("");
                                        }} />}
                                        label="เดินทางเที่ยวเดียว" />
                                </Col>
                                <Col xs={12} sm={12} md={6}>
                                    <Label>ในวันที่</Label>
                                    <FormGroup
                                        style={{ padding: '0 0px', marginBottom: '10px' }}
                                        className={
                                            "input-lg" + (dateFocus ? " input-group-focus" : "")
                                        }
                                    >
                                        <i className="far fa-calendar-check fa-2x" style={{
                                            position: 'absolute',
                                            left: '30px',
                                            zIndex: 1,

                                        }}
                                        ></i>
                                        <Datetime
                                            value={moment(StartDatetime).isValid() ? moment(StartDatetime) : null}
                                            renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                            isValidDate={isDateValid}
                                            renderDay={renderDay}
                                            //onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                            //onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                            //onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                            inputProps={{
                                                name: "StartDatetime", placeholder: "วันที่เดินทาง", readOnly: 'readonly'
                                                , style: {
                                                    fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                }
                                            }}
                                            closeOnSelect={true}
                                            closeOnTab={true}
                                            dateFormat="D MMMM BBBB" timeFormat={false}
                                            //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                            //timeFormat={false}
                                            onFocus={() => setDateFocus(true)}
                                            onBlur={() => setDateFocus(false)}
                                            onChange={e => handleStartDatetime(e.format('YYYY-MM-DD'))}


                                        />


                                    </FormGroup>
                                </Col>


                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="เวลา" options={ArrStartTime} value={StartTime} onChange={e => handleStartTime(e.value)} />
                                </Col>

                                {!IsOneWay && <>
                                <Col xs={12} sm={12} md={6}>
                                    <Label>ถึงวันที่</Label>
                                    <FormGroup
                                        style={{ padding: '0 0px', marginBottom: '10px' }}
                                        className={
                                            "input-lg" + (dateFocus ? " input-group-focus" : "")
                                        }
                                    >
                                        <i className="far fa-calendar-check fa-2x" style={{
                                            position: 'absolute',
                                            left: '30px',
                                            zIndex: 1,

                                        }}
                                        ></i>
                                        <Datetime
                                            value={moment(EndDatetime).isValid() ? moment(EndDatetime) : null}
                                            renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                            isValidDate={isDateValid}
                                            renderDay={renderDay}
                                            //onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                            //onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                            //onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                            inputProps={{
                                                name: "EndDatetime", placeholder: "วันที่กลับ", readOnly: 'readonly'
                                                , style: {
                                                    fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                }
                                            }}
                                            closeOnSelect={true}
                                            closeOnTab={true}
                                            dateFormat="D MMMM BBBB" timeFormat={false}
                                            //dateFormat="D MMMM BBBB" timeFormat="เวลา HH:mm น."
                                            //timeFormat={false}
                                            onFocus={() => setDateFocus(true)}
                                            onBlur={() => setDateFocus(false)}
                                            onChange={e => handleEndDatetime(e.format('YYYY-MM-DD'))}


                                        />


                                    </FormGroup>
                                </Col>


                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="เวลา" options={ArrStopTime} value={EndTime} onChange={e => setEndTime(e.value)} />
                                </Col>
                                </>}
                                {IsOneWay && <Col xs={12}><p style={{ color: "#075985", margin: "4px 0 12px" }}>เที่ยวเดียว</p></Col>}


                                <Col xs={12} sm={12} md={12}>
                                    <div className="textarea-container" style={{ padding: 0 }}>
                                        <Label for="Address">หมายเหตุ </Label>
                                        {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                        <Input
                                            id="VBDescription"
                                            cols="80"
                                            name="VBDescription"
                                            placeholder="หมายเหตุ"
                                            rows="4"
                                            type="textarea"
                                            className="custom"
                                            style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                            value={VBDescription}
                                            onChange={e => setVBDescription(e.target.value)}
                                        ></Input>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={6}>
                                    <TSText icon="far fa-edit" label="หมายเลขโทรศัพท์ติดต่อผู้ขอใช้" value={ContactPhone} onChange={e => setContactPhone(e.target.value)} />
                                </Col>
                                <Col xs={12} sm={12} md={6}>
                                    <TSText type="tel" icon="far fa-edit" label="จำนวนผู้โดยสาร" value={TotalPassenger} onChange={e => setTotalPassenger(e.target.value)} />
                                </Col>

                                {/* 
                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="VBKey" options={ArrVB} value={VBKey} onChange={e => setVBKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="VBID" value={VBID} onChange={e => setVBID(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="VBTypeKey" options={ArrVBType} value={VBTypeKey} onChange={e => setVBTypeKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="TeamGroupTypeKey" options={ArrTeamGroupType} value={TeamGroupTypeKey} onChange={e => setTeamGroupTypeKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="TeamGroupKey" options={ArrTeamGroup} value={TeamGroupKey} onChange={e => setTeamGroupKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="DepartmentKey" options={ArrDepartment} value={DepartmentKey} onChange={e => setDepartmentKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="TeamName" value={TeamName} onChange={e => setTeamName(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="VBName" value={VBName} onChange={e => setVBName(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="VBStatusKey" options={ArrVBStatus} value={VBStatusKey} onChange={e => setVBStatusKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="VehicleKey" options={ArrVehicle} value={VehicleKey} onChange={e => setVehicleKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="VehicleOther" value={VehicleOther} onChange={e => setVehicleOther(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                    <TSSelect2 label="VBStyleKey" options={ArrVBStyle} value={VBStyleKey} onChange={e => setVBStyleKey(e.value) } />
                                  </Col> 

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="StartLatLong" value={StartLatLong} onChange={e => setStartLatLong(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="EndLatLong" value={EndLatLong} onChange={e => setEndLatLong(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="StartGauge" value={StartGauge} onChange={e => setStartGauge(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="EndGauge" value={EndGauge} onChange={e => setEndGauge(e.target.value)} />
                                </Col>                               

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="DriverUserName" value={DriverUserName} onChange={e => setDriverUserName(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="IsCancel" value={IsCancel} onChange={e => setIsCancel(e.target.value)} />
                                </Col>

                                <Col xs={12} sm={12} md={6}>
                                      <TSText icon="far fa-edit" label="CancelCode" value={CancelCode} onChange={e => setCancelCode(e.target.value)} />
                                </Col>
                                */}
                            </Grid>


                            <Grid> 
                             
                             {(location.state != null && location.state != '' && location.state.VBID != null && location.state.VBID != '') ? 

                                  <Col xs={12} sm={6} md={6}>
                                    <div>ผู้จอง {CreatorName} {CreateDatetime != "" ? moment(CreateDatetime).format('DD MMM BB HH:mm').toString():""}</div>
                                    
                                    {EditerName != "" ?
                                    <div>แก้ไขล่าสุด {EditerName} {LastEditDatetime != "" ? moment(LastEditDatetime).format('DD MMM BB HH:mm').toString():""}</div>
                                    : <></>
                                    }

                                    {CancelerName != "" ?
                                    <div>ยกเลิกโดย {CancelerName} {CancelerName != "" ? moment(CancelDatetime).format('DD MMM BB HH:mm').toString():""}</div>
                                    : <></>
                                    }
                                </Col>
                             :
                                <Col xs={12} sm={6} md={6}></Col>
                             }
                            </Grid>
                            
                            <Grid>
                              <Col xs={12} sm={12} md={12}>  
                              
                              </Col>
                            </Grid>


                      </CardBody>
                      <CardFooter>
                          <Collapse isOpen={isOpen}>

                          </Collapse>
                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยกเลิก</h4>
                                    </Button>


                                </div>
                            </Modal>
                            {/* Cancel */}
                            <Modal toggle={() => setModalCancel(false)} isOpen={modalCancel}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "red", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center", fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันยกเลิกการประชุม"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">

                                    <Button
                                        color="success"
                                        type="button"
                                        onClick={handleCancel}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => { setIcon("far fa-question-circle"); setModalCancel(false); }}
                                    >
                                        <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
                                        <h4>ปฏิเสธ</h4>
                                    </Button>


                                </div>
                            </Modal>

                         {/* Success */}
                         <Modal toggle={GotoEdit} isOpen={modal2}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={"fas fa-check"}
                                  style={{ color: "green", fontSize: "4em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center", fontSize: "1.8em"
                                }}
                              >
                               บันทึกข้อมูลสำเร็จ

                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="info"
                                type="button"
                                onClick={GotoEdit}
                              >
                                <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }}></i>
                                <h4>ตกลง</h4>
                              </Button>
                             
                            </div>
                          </Modal>           

                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p>ไม่สามารถบันทึกข้อมูลได้</p>
                              <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                          </Modal>


                      </CardFooter>
                    </Card>
                </Col>

                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.cardTitleCustom}>

                              <h4 className={classes.cardTitleWhite}>ผู้โดยสาร</h4>
                              <p className={classes.cardCategoryWhite}>  </p>

                          </CardHeader>
                          <CardBody>                          
                              <Grid>
                                  <Col xs={12} sm={12} md={12}>
                                  <TSUser value={Attendee} isMultiple={true} onChange={e => { handleAttendee(e) } } />
                                  </Col>
                              </Grid>
                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                            {/* Confirm */}
                        </CardFooter>
                    </Card>
                </Col>



                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader className={classes.cardTitleCustom}>

                              <h4 className={classes.cardTitleWhite}>บันทึกข้อมูล</h4>
                              <p className={classes.cardCategoryWhite}>  </p>

                          </CardHeader>
                          <CardBody>                          
                            <Grid>
                              
                              {(location.state != null && location.state != '' && location.state.meetingID != null && location.state.meetingID != '') ? 
                              <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                  <Button color="warning" onClick={handleSubmit} fullWidth>
                                    <i className={"fa fa-edit"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                    <h4>แก้ไข</h4>
                                  </Button>
                              </Col>
                              :
                              <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                <Button color="info" onClick={handleSubmit} fullWidth>
                                  <i className={"fa fa-save"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                  <h4>บันทึก</h4>
                                </Button>
                              </Col>
                              }

                                <Col xs={12} sm={12} md={2} >
                                  <>&nbsp;</>             
                                </Col>

                                <Col xs={12} sm={12} md={5} style={{ height: "48px" }}>
                                <Button color="danger" onClick = {() => { setModalCancel(true); }} fullWidth>
                                  <i className={"fa fa-ban"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                              <h4>ยกเลิก</h4>
                                  </Button>
                                </Col>
                            </Grid>
                            <Grid><Col>&nbsp;</Col></Grid>
                      
                        </CardBody>
                    </Card>
                </Col>


            </Grid>
        </div>
    );
}
export default Request;

